import React from "react";
export function LinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.19922 9.54397C7.45811 9.90339 7.7884 10.2008 8.1677 10.416C8.547 10.6312 8.96644 10.7592 9.39755 10.7912C9.82866 10.8233 10.2614 10.7587 10.6663 10.6018C11.0713 10.4449 11.439 10.1995 11.7446 9.88202L13.5531 8.00393C14.1022 7.41358 14.406 6.62289 14.3991 5.80217C14.3922 4.98146 14.0752 4.19638 13.5164 3.61602C12.9575 3.03566 12.2015 2.70647 11.4112 2.69934C10.6209 2.69221 9.85954 3.00771 9.29106 3.57789L8.25418 4.6484"
        stroke="#8C8E95"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.89922 8.315C9.64034 7.99552 9.31004 7.73116 8.93074 7.53987C8.55144 7.34858 8.13201 7.23483 7.70089 7.20633C7.26978 7.17783 6.83707 7.23525 6.43211 7.37469C6.02715 7.51413 5.65941 7.73234 5.35384 8.01451L3.54533 9.68393C2.99628 10.2087 2.69247 10.9115 2.69933 11.641C2.7062 12.3706 3.0232 13.0684 3.58205 13.5843C4.1409 14.1002 4.8969 14.3928 5.68721 14.3991C6.47751 14.4055 7.2389 14.125 7.80738 13.6182L8.83823 12.6666"
        stroke="#8C8E95"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default LinkIcon;
